<template>
  <Layout>
    <div>
      <Transition name="fade" mode="out-in">
        <div v-if="!emailSent" key="reset-form">
          <h1 class="text-base mb-2">Reset your password</h1>
          <p class="help text-sm">
            Please enter the email address used for your account and we will email you a link with next steps.
          </p>
          <form class="max-w-sm mx-auto" @submit.prevent="onResetPassword">
            <DrInput id="email" v-model="email" :error="form.errors.email" icon="email" />
            <DrButton id="submit" type="submit" class="btn btn-cyan w-full mt-4 rounded-full" :loading="loading">
              Reset password
            </DrButton>
          </form>
        </div>
        <div v-if="emailSent" key="email-sent">
          <div class="text-center">
            <h1 class="text-base icon-email-stars">Check your inbox</h1>
            <div class="text-sm">
              <p>We've sent an email to reset your password. You should receive it in a matter of minutes!</p>
              <p>Don't forget to check your spam if you can't find it.</p>
              <p>
                Go back to
                <RouterLink
                  class="font-semibold no-underline text-blue-500 cursor-pointer" to="/login"
                >
                  login
                </RouterLink>.
              </p>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/Full.vue'

export default {
  components: {
    Layout,
  },
  data () {
    return {
      // errors: [],
      form: {
        errors: {
          email: null,
        },
      },
      email: '',
      emailSent: false,
    }
  },
  computed: {
    loading () {
      return this.$store.getters['shared/loading']
    },
    user () {
      return this.$store.getters['user/user']
    },
    error () {
      const error = this.$store.getters['shared/error']
      return error
    },
  },
  watch: {
    error (error) {
      // Customise the firebase error messages
      // https://firebase.google.com/docs/auth/admin/errors
      if (error && error.code) {
        switch (error.code) {
          case 'auth/invalid-email':
            this.form.errors.email = 'Invalid email'
            break
          case 'auth/user-not-found':
            this.form.errors.email = 'No account for this email'
            break
        }
      }
      if (error && error.message) {
        switch (error.message) {
          case 'Email can not be blank':
            this.form.errors.email = 'Email required'
            break
        }
      } else this.form.errors.email = ''
    },
  },
  mounted () {
    this.$store.dispatch('shared/clearError')
  },
  methods: {
    onResetPassword () {
      if (!this.email) {
        return this.$store.dispatch('shared/setError', {
          message: 'Email can not be blank',
        })
      }
      if (this.error) this.$store.dispatch('shared/clearError')
      this.$store.dispatch('user/resetPasswordWithEmail', { email: this.email }).then((res) => {
        if (!this.form.errors.email) {
          this.emailSent = true
        }
      })
    },
  },
}
</script>

<style scoped>
.icon-email-stars {
  padding-top: 80px;
  background: url('./../../../assets/img/style/icons/email-stars.svg') no-repeat center 0;
  background-size: auto 59px;
}

.text-sm p {
  @apply text-sm;
}
</style>
